export default __webpack_public_path__ + "/dist/images/image6.8a03c67993f8b5a21330ddfc9cb79400.jpg";